/* eslint-disable security/detect-object-injection */
import { css, FlattenSimpleInterpolation } from "styled-components/macro";

const breakpoints = {
    xs: 400,
    sm: 600,
    md: 800,
    lg: 1100,
    xl: 1800,
};

export default breakpoints;

export const forMinWidth = Object.keys(breakpoints)
    .reduce((acc, cur) => {
        acc[cur] = (
            strings: TemplateStringsArray,
            ...values: any[]
        ) => css`
            @media (min-width: ${breakpoints[cur]}px) {
                ${css(strings, ...values)};
            }
        `;
        return acc;
    },
        {} as Record<
            keyof typeof breakpoints,
            (l: TemplateStringsArray, ...p: any[]) => FlattenSimpleInterpolation
        >,
    );
